import { render, staticRenderFns } from "./AboutUsSections.vue?vue&type=template&id=5aef3c0e&"
import script from "./AboutUsSections.vue?vue&type=script&lang=js&"
export * from "./AboutUsSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports